module.exports = __webpack_public_path__ + "Flag-191.7a7599280623548d0ee522b408fac843.svg";